export function cognitoApiDefautHeaders(session) {
  return {
    Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
    "Content-Type": "application/json",
    Accept: "application/json"
  };
}
